import React from "react";
import { UseFormRegisterReturn } from "react-hook-form";

type InputProps = {
  id?: string;
  label?: string;
  placeholder?: string;
  type?: "text" | "email" | "number" | "Date" | "percentage";
  disabled?: boolean;
  required?: boolean;
  className?: string;
  inputClassName?: string;
  error?: string;
  registration?: UseFormRegisterReturn;
  onChange?: (value: string) => void;
  max?: string | number;
  min?: string | number;
  step?: string | number;
  value?: string;
};

export const Input: React.FC<InputProps> = ({
  id,
  label,
  placeholder,
  type = "text",
  disabled = false,
  required = false,
  className,
  inputClassName,
  error,
  registration,
  onChange,
  max,
  min,
  step,
  value,
}) => {
  const { name, ref, onBlur, onChange: rhfOnChange } = registration ?? {};

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (type === "percentage") {
      const inputVal = parseInt(e.target.value);
      if (isNaN(inputVal)) {
        e.target.value = "";
      }
      if (inputVal > 100) e.target.value = "100";
      if (inputVal === 0) e.target.value = "";
    }

    rhfOnChange?.(e);
    onChange?.(e.target.value);
  };

  return (
    <div className={className}>
      {label && (
        <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
          {label}
        </label>
      )}
      <input
        id={id}
        name={name}
        type={type === "percentage" ? "text" : type}
        pattern={type === "percentage" ? "^([0-9]{1,2}|100)$" : undefined}
        max={max}
        min={min}
        step={step}
        placeholder={placeholder}
        disabled={disabled}
        required={required}
        onBlur={onBlur}
        onChange={handleChange}
        ref={ref}
        value={value}
        className={`bg-gray-50 border ${
          error ? "border-red-500" : "border-gray-300"
        } text-gray-900 text-sm rounded-lg block w-full p-3 focus:ring-blue-500 focus:border-blue-500 focus:outline-none disabled:bg-gray-100 disabled:cursor-not-allowed ${inputClassName || ''}`}
      />
      {error && <p className="text-red-500 text-sm mt-1">{error}</p>}
    </div>
  );
};
